module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_item_message":"已登记的视频不存在。"}}')
  delete Component.options._Ctor
}
